<div class="file-container" [style]="{height: height}">
  <div class="file" [style]="{height: height}">
    <img *ngIf="fileUrl" mat-card-image [src]="fileUrl" alt="Alphazed" [height]="height">
  </div>
</div>
